import { put, select, takeEvery } from 'redux-saga/effects';

import { getPatientPageUrlId } from 'store/selectors/router';
import { patientUpdate, requestPatientUpdate } from 'store/actionCreators/patientsData';

export function* onUpdatePatientInit() {
  const patientId = yield select(getPatientPageUrlId);

  yield put(requestPatientUpdate({ id: patientId }));
}

export default function*() {
  yield takeEvery(patientUpdate, onUpdatePatientInit);
}
